import { render, staticRenderFns } from "./SmallSlider.vue?vue&type=template&id=0dc4542b"
import script from "./SmallSlider.vue?vue&type=script&lang=js"
export * from "./SmallSlider.vue?vue&type=script&lang=js"
import style0 from "./SmallSlider.vue?vue&type=style&index=0&id=0dc4542b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports